/* Skyteck shipping estimator — zone engine + PDP/cart widget controllers.
   Zone prices MUST mirror the live Bespoke Shipping config (changed there → change here).
   The cart widget upgrades the zone estimate with the LIVE checkout rate from
   /cart/shipping_rates.json (cart-scoped, so it is exact); the zone table remains the
   instant estimate + offline fallback. Checkout stays ground truth.
   2026-07-08 consignment model for the instant estimate (draft-order-probe verified):
   tag-bulky or unit≥25kg lines pool into ONE bulky consignment; a line whose unit is
   under 25kg but whose line total (unit×qty) crosses 25kg is its OWN consignment
   ("crossers", emitted by sections/skyteck-shipping-cart.liquid); light lines pool.
   Each consignment's kg rounds UP to a whole kg. Line-crosser behaviour is INTERIM
   pending the Bespoke support ticket (task #13) — if they scope the rule back to unit
   weight, drop the crosser handling here, in the cart section, and in PDP isBulky(). */
(function () {
  'use strict';
  if (window.__skShipInit) return;
  window.__skShipInit = true;

  var PERTH = { 6100: 1, 6101: 1, 6102: 1, 6103: 1, 6104: 1, 6105: 1, 6106: 1, 6107: 1, 6110: 1, 6147: 1, 6151: 1, 6152: 1, 6155: 1 };
  /* Zone-aware delivery promise: metro runs 7 business days; regional NSW + WA 10;
     CQ mining runs are batched — 14. Tune here if ops cadence changes. */
  function etaFor(pc) {
    if (PERTH[pc]) return ' — arrives within 7 business days';
    if (inRange(pc, 4713, 4728) || inRange(pc, 4742, 4746) || pc === 4709) return ' — arrives within 14 business days';
    if (inRange(pc, 2331, 2897) || inRange(pc, 6000, 6999)) return ' — arrives within 10 business days';
    return ' — arrives within 7 business days';
  }

  function inRange(pc, lo, hi) { return pc >= lo && pc <= hi; }

  /* Postcode → state for the live rates call. */
  function provinceFor(pc) {
    if (inRange(pc, 200, 299) || inRange(pc, 2600, 2618) || inRange(pc, 2900, 2920)) return 'Australian Capital Territory';
    if (inRange(pc, 1000, 2599) || inRange(pc, 2619, 2899) || inRange(pc, 2921, 2999)) return 'New South Wales';
    if (inRange(pc, 3000, 3999) || inRange(pc, 8000, 8999)) return 'Victoria';
    if (inRange(pc, 4000, 4999) || inRange(pc, 9000, 9999)) return 'Queensland';
    if (inRange(pc, 5000, 5999)) return 'South Australia';
    if (inRange(pc, 6000, 6999)) return 'Western Australia';
    if (inRange(pc, 7000, 7999)) return 'Tasmania';
    if (inRange(pc, 800, 999)) return 'Northern Territory';
    return '';
  }

  /* Returns {price, label} or {fallback:true}. One call = one consignment;
     kg rounds UP to a whole kg (checkout-verified); items = qty in the consignment. */
  function estimate(pc, grams, items, bulky) {
    if (!grams || grams <= 0) return { fallback: true };
    var kg = Math.ceil(grams / 1000);
    items = items || 1;
    if (inRange(pc, 4000, 4199) || inRange(pc, 4300, 4306)) return { price: 25 + (bulky ? 0.50 : 0.40) * kg, label: 'Brisbane metro & Ipswich' }; /* bulky 0.50 since 2026-07-09 */
    if (inRange(pc, 4200, 4299) || inRange(pc, 4500, 4521) || inRange(pc, 4550, 4569) || inRange(pc, 4571, 4575)) return { price: 39 + 0.50 * kg, label: 'Gold Coast & Sunshine Coast' };
    if (inRange(pc, 4350, 4352)) return { price: 59 + 0.50 * kg, label: 'Toowoomba' };
    if (inRange(pc, 4713, 4728)) { /* CQ Highlands (Blackwater/Emerald) — bulky-only zone */
      if (bulky) return { price: 80 + 0.50 * items + 1.85 * kg, label: 'Central QLD Highlands' };
      return { fallback: true };
    }
    if (inRange(pc, 4742, 4746) || pc === 4709) { /* Bowen Basin (Moranbah/Dysart/Tieri) — bulky-only zone */
      if (bulky) return { price: 115 + 0.50 * items + 2.60 * kg, label: 'Bowen Basin' };
      return { fallback: true };
    }
    if (inRange(pc, 2000, 2249)) return { price: ((17.25 + 0.65 * kg + 0.5 * items) * 1.2) + 1.20, label: 'Sydney metro' };
    if (inRange(pc, 2250, 2330) || inRange(pc, 2500, 2530)) return { price: 25 + 0.75 * kg, label: 'Newcastle, Central Coast & Illawarra' };
    if (inRange(pc, 2331, 2897)) return { price: 45 + 1.40 * kg, label: 'Regional NSW & ACT' };
    if (inRange(pc, 3000, 3230)) return { price: 22 + 0.67 * kg, label: 'Melbourne & Geelong' };
    if (inRange(pc, 5000, 5174)) return { price: 37 + 0.70 * kg, label: 'Adelaide metro' };
    if (PERTH[pc]) return { price: 80, label: 'Perth metro' };
    if (inRange(pc, 6000, 6999)) {
      if (bulky) return { price: 100 + 1.11 * kg, label: 'WA' };
      return { fallback: true };
    }
    return { fallback: true };
  }

  var fmt = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });
  function money(n) { return fmt.format(Math.round(n * 100) / 100).replace(/\.00$/, ''); }

  function savePc(pc) { try { localStorage.setItem('sk_postcode', pc); } catch (e) { /* private mode */ } }
  function loadPc() { try { return localStorage.getItem('sk_postcode') || ''; } catch (e) { return ''; } }

  /* Live checkout rates for the CURRENT cart. Exact — matches what checkout will show. */
  var liveCache = {};
  function liveRates(pcStr, cb) {
    if (liveCache[pcStr]) { cb(liveCache[pcStr]); return; }
    var pc = parseInt(pcStr, 10);
    var province = provinceFor(pc);
    var url = '/cart/shipping_rates.json?shipping_address[zip]=' + encodeURIComponent(pcStr)
      + '&shipping_address[country]=Australia'
      + (province ? '&shipping_address[province]=' + encodeURIComponent(province) : '');
    var attempt = 0;
    function go() {
      attempt++;
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (r.status === 202 && attempt < 3) { setTimeout(go, 1500); return null; }
          return r.ok ? r.json() : null;
        })
        .then(function (j) {
          if (j === null) { if (attempt >= 3) cb(null); return; }
          var rates = (j && j.shipping_rates) || [];
          if (!rates.length) { cb(null); return; }
          var cheapest = rates.reduce(function (a, b) { return parseFloat(a.price) <= parseFloat(b.price) ? a : b; });
          var out = { price: parseFloat(cheapest.price), multiple: rates.length > 1 };
          liveCache[pcStr] = out;
          cb(out);
        })
        .catch(function () { cb(null); });
    }
    go();
  }

  /* ---------- PDP widget ---------- */
  function initPdp() {
    var dataEl = document.querySelector('[data-sk-ship-data]');
    if (!dataEl || dataEl.__skInit) return;
    dataEl.__skInit = true;
    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var weights = cfg.weights || {};
    var variantId = String(cfg.selected || '');
    /* bulky = tagged OR the line total (unit×qty) crosses 25kg — mirrors Bespoke's
       _weight gte 25 rule as it actually evaluates at checkout (line weight; subsumes
       the unit≥25kg case at any qty). INTERIM per task #13. */
    function isBulky() { return !!cfg.bulky || (weights[variantId] || 0) * qty() >= 25000; }

    var root = dataEl.parentElement;
    var chipsEl = root.querySelector('[data-sk-chips]');
    var inputEl = root.querySelector('[data-sk-postcode]');
    var checkEl = root.querySelector('[data-sk-check]');
    var resultEl = root.querySelector('[data-sk-result]');

    /* Dawn's qty input sits OUTSIDE the product form (linked via form= attribute) */
    function qty() {
      var q = document.querySelector('.product-form__input input[name="quantity"], quantity-input input[name="quantity"], input[name="quantity"][form], form[action*="/cart/add"] input[name="quantity"]');
      var n = q ? parseInt(q.value, 10) : 1;
      return (n && n > 0) ? n : 1;
    }
    function grams() {
      var g = weights[variantId];
      return (g && g > 0) ? g * qty() : 0;
    }

    function renderChips() {
      var g = grams();
      if (!g) { chipsEl.textContent = ''; return; }
      var anchors = [['Brisbane', 4000], ['Sydney', 2000], ['Melbourne', 3000]];
      var parts = [];
      for (var i = 0; i < anchors.length; i++) {
        var est = estimate(anchors[i][1], g, qty(), isBulky());
        if (est && !est.fallback) parts.push(anchors[i][0] + ' ' + money(est.price));
      }
      chipsEl.textContent = parts.length ? 'e.g. ' + parts.join(' · ') : '';
    }

    function showResult(pcStr) {
      var pc = parseInt(pcStr, 10);
      if (!pcStr || pcStr.length < 3 || isNaN(pc)) { resultEl.style.display = 'none'; return; }
      var est = estimate(pc, grams(), qty(), isBulky());
      resultEl.style.display = 'block';
      if (est.fallback) {
        resultEl.style.color = '#0e1b4d';
        resultEl.textContent = '🚚 We deliver to ' + pcStr + ' Australia-wide. Add to cart to see your exact freight — no surprises at checkout.';
      } else {
        resultEl.style.color = '#1a7f37';
        resultEl.textContent = '🚚 Delivery to ' + pcStr + ' (' + est.label + '): ' + money(est.price) + etaFor(pc);
      }
      savePc(pcStr);
    }
    function refresh() { renderChips(); if (inputEl.value.trim()) showResult(inputEl.value.trim()); }

    checkEl.addEventListener('click', function () { showResult(inputEl.value.trim()); });
    inputEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); showResult(inputEl.value.trim()); } });

    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (event) {
        try {
          if (event && event.data && event.data.variant) { variantId = String(event.data.variant.id); refresh(); }
        } catch (e) { /* never break the PDP */ }
      });
    }
    /* qty +/- buttons and typed changes both bubble a change event to document */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'quantity') refresh();
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('quantity-input button')) setTimeout(refresh, 50);
    });

    renderChips();
    var saved = loadPc();
    if (saved) { inputEl.value = saved; showResult(saved); }
  }

  /* ---------- Cart widget ---------- */
  function wireCart(root) {
    if (!root || root.__skInit) return;
    root.__skInit = true;
    var cfg;
    try { cfg = JSON.parse(root.querySelector('[data-sk-cart-ship]').textContent); } catch (e) { return; }
    var input = root.querySelector('[data-sk-cart-postcode]');
    var btn = root.querySelector('[data-sk-cart-check]');
    var out = root.querySelector('[data-sk-cart-result]');
    var seq = 0;

    function show(pcStr) {
      var pc = parseInt(pcStr, 10);
      if (!pcStr || pcStr.length < 3 || isNaN(pc)) { out.style.display = 'none'; return; }
      var mySeq = ++seq;
      var total = 0, fallback = false;
      function addConsignment(grams, items, bulky) {
        if (!(grams > 0)) return;
        var e = estimate(pc, grams, items, bulky);
        if (e.fallback) fallback = true; else total += e.price;
      }
      addConsignment(cfg.bulkyGrams, cfg.bulkyItems, true);
      /* each line-crosser (unit<25kg, line total ≥25kg) is its own consignment */
      var crossers = cfg.crossers || [];
      for (var i = 0; i < crossers.length; i++) addConsignment(crossers[i].g, crossers[i].q, true);
      addConsignment(cfg.lightGrams, cfg.lightItems, false);
      out.style.display = 'block';
      if (fallback || total <= 0) {
        out.style.color = '#0e1b4d';
        out.textContent = '🚚 Checking your exact delivery price for ' + pcStr + '…';
      } else {
        out.style.color = '#1a7f37';
        out.textContent = '🚚 Estimated delivery to ' + pcStr + ': ' + money(total);
      }
      savePc(pcStr);
      /* Upgrade to the LIVE checkout rate for this exact cart. */
      liveRates(pcStr, function (live) {
        if (mySeq !== seq) return; /* stale response — a newer check ran */
        if (live && live.price > 0) {
          out.style.color = '#1a7f37';
          out.textContent = '🚚 Delivery to ' + pcStr + ': ' + (live.multiple ? 'from ' : '') + money(live.price) + etaFor(pc) + ' (exact checkout price)';
        } else if (fallback || total <= 0) {
          out.style.color = '#0e1b4d';
          out.textContent = '🚚 We deliver to ' + pcStr + ' — exact freight shown at checkout.';
        }
      });
    }

    btn.addEventListener('click', function () { show(input.value.trim()); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); show(input.value.trim()); } });

    var saved = loadPc();
    if (saved) { input.value = saved; show(saved); }
    return { sectionId: cfg.sectionId };
  }

  var cartSectionId = null;
  function refreshCartSection() {
    if (!cartSectionId) return;
    liveCache = {}; /* cart contents changed — cached rates no longer valid */
    fetch(window.location.pathname + '?sections=' + encodeURIComponent(cartSectionId))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[cartSectionId];
        /* section id key can differ from Liquid's section.id in some setups — fall back to the first key */
        if (!html) { var keys = Object.keys(data || {}); if (keys.length === 1) html = data[keys[0]]; }
        if (!html) return;
        var current = document.querySelector('[data-sk-cart-root]');
        if (!current) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-sk-cart-root]');
        if (fresh) { current.replaceWith(fresh); wireCart(fresh); }
      }).catch(function () { /* keep old estimate */ });
  }
  /* double-tap: once after the cart AJAX likely finished, once more to catch slow updates */
  function scheduleCartRefresh() { setTimeout(refreshCartSection, 700); setTimeout(refreshCartSection, 2200); }

  function initCart() {
    var root = document.querySelector('[data-sk-cart-root]');
    if (!root) return;
    var info = wireCart(root);
    if (info) cartSectionId = info.sectionId;
    if (window.__skCartWatch) return;
    window.__skCartWatch = true;
    /* Event-source-agnostic: watch the cart page's own controls (theme pubsub kept as bonus path) */
    document.addEventListener('change', function (e) {
      var n = e.target && e.target.name || '';
      if (n.indexOf('updates') === 0 || n === 'quantity') scheduleCartRefresh();
    });
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('quantity-input button, cart-remove-button, .cart-remove-button, a[href*="/cart/change"], button[name="minus"], button[name="plus"]')) {
        scheduleCartRefresh();
      }
    });
    /* this script is deferred, so pubsub/global.js are already loaded if the theme has them */
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refreshCartSection, 250); });
    }
  }

  window.SkyteckShipping = { estimate: estimate, money: money, initCart: initCart, liveRates: liveRates };

  function init() { initPdp(); initCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
